
import { AlertCircle } from "lucide-react";

interface EmptyStateProps {
  isAuthenticated: boolean;
}

export function EmptyState({ isAuthenticated }: EmptyStateProps) {
  if (!isAuthenticated) {
    return (
      <div className="text-center p-6 bg-muted/20 rounded-lg">
        <AlertCircle className="h-10 w-10 text-muted-foreground mx-auto mb-3" />
        <h3 className="text-lg font-medium mb-1">Accesso richiesto</h3>
        <p className="text-muted-foreground mb-1">
          Effettua l'accesso per visualizzare e gestire i tuoi avvisi di prezzo
        </p>
      </div>
    );
  }

  return (
    <div className="text-center p-6 bg-muted/20 rounded-lg">
      <AlertCircle className="h-10 w-10 text-muted-foreground mx-auto mb-3" />
      <h3 className="text-lg font-medium mb-1">Nessun avviso di prezzo</h3>
      <p className="text-muted-foreground mb-1">
        Non hai ancora creato avvisi di prezzo. Utilizza il modulo per creare un nuovo avviso.
      </p>
    </div>
  );
}
